import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import Notifications from '../../../components/notifications';

export type MobileNotificationsSidebarProps = {
  isOpen: boolean;
  onClose: () => void;
};

const MobileNotificationsSidebar = ({ isOpen, onClose }: MobileNotificationsSidebarProps) => {
  return (
    <SwipeableDrawer
      variant="temporary"
      anchor="right"
      open={isOpen}
      onClose={onClose}
      onOpen={onClose}
      ModalProps={{
        BackdropProps: {
          onClick: onClose
        }
      }}
    >
      <Notifications onClose={onClose} />
    </SwipeableDrawer>
  );
};

export default MobileNotificationsSidebar;
